export default class UserInfoModel {
  constructor () {
    this.authResult = null
    this.userId = null
    this.passwd = null
    this.userName = null
    this.permission = null
    this.officeGroup = null
    this.userStatus = null
    this.companyCode = null
    this.division = null
    this.userImage = null
    this.token = null
    this.refreshToken = null
    this.userImage = null
  }
}
